
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreditCardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.636 6.2a1.84 1.84 0 0 1 1.841-1.84h17.455a1.84 1.84 0 0 1 1.84 1.84v12a1.84 1.84 0 0 1-1.84 1.841H3.477a1.84 1.84 0 0 1-1.84-1.84v-12zm1.841-.34a.34.34 0 0 0-.34.34v12a.34.34 0 0 0 .34.341h17.455a.34.34 0 0 0 .34-.34v-12a.34.34 0 0 0-.34-.342H3.477z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.84 8.385h20.183v3.818H1.84V8.385z",
  fill: "#000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 16.5H15",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.636 6.2a1.84 1.84 0 0 1 1.841-1.84h17.455a1.84 1.84 0 0 1 1.84 1.84v12a1.84 1.84 0 0 1-1.84 1.841H3.477a1.84 1.84 0 0 1-1.84-1.84v-12zm1.841-.34a.34.34 0 0 0-.34.34v12c0 .189.152.341.34.341h17.455a.34.34 0 0 0 .34-.34v-12a.34.34 0 0 0-.34-.342H3.477z\" fill=\"#000\"/>\r\n    <path d=\"M1.84 8.385h20.183v3.818H1.84V8.385z\" fill=\"#000\"/>\r\n    <path d=\"M19.5 16.5H15\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/credit-card-icon.8948d0c4427400a69a43957efad25c47.svg"),
        {
          React: SvgCreditCardIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      